export default {
  PRIVACY_POLICY: [
    'd0790122-0629-449d-ab57-04e0c33b7f7d',
    '796fe7e7-cd92-43e3-a53b-bcef1382c8b8'
  ],
  TERMS_AND_CONDITIONS: [
    'e3f5d573-a693-4d22-9546-9e602b176e66',
    '97072540-d4ab-44bc-9192-b512faf1ae02'
  ]
}
